import type { SeasonPassDependencies } from './types';
import { getSeasonPassInfo } from './model/seasonPassUtils';

export function addSeasonPassTokens(dependencies: SeasonPassDependencies, amount: number): void {
  const { seasonPass } = dependencies.observable.getValue();
  if (!seasonPass) return;
  if (Date.now() > seasonPass.endTime) return;

  dependencies.observable.updateValue({
    seasonPass: {
      ...seasonPass,
      tokensCollected: seasonPass.tokensCollected + amount,
    },
  });

  dependencies?.onProgressIncrease?.(getSeasonPassInfo(seasonPass), amount);
}
